import styled from "styled-components";
import { palletFormatter } from "../../helpers/formatters";
import { ApplicationBasketSupplierTotals } from "../../models/order/basket/application-basket-supplier-totals";

interface PalletBreakdownProps {
  suppliers: ApplicationBasketSupplierTotals[];
}

export default function PalletBreakdown({ suppliers }: PalletBreakdownProps) {
  const palletSuppliers = suppliers.filter(
    (supplier) => supplier.currentTotalPalletEquivalent != null
  );

  if (palletSuppliers.length === 0) {
    return null;
  }

  return (
    <Container aria-label="Pallet Breakdown">
      <Title>Pallet Breakdown</Title>
      {palletSuppliers.map((supplier) => {
        const met = supplier.isPalletMinimumMet ?? ((supplier.palletShortfall ?? 0) <= 0);
        return (
          <Supplier key={`pallet-${supplier.supplierId}`} $met={met}>
            <strong>{supplier.supplierName}</strong>
            <span>{palletFormatter(supplier.currentTotalPalletEquivalent ?? 0)} pallets</span>
            {supplier.requiredMinimumPallets == null ? (
              <span>No supplier minimum</span>
            ) : met ? (
              <span>Minimum met</span>
            ) : (
              <span>{palletFormatter(supplier.palletShortfall ?? 0)} pallets still required</span>
            )}
          </Supplier>
        );
      })}
    </Container>
  );
}

const Container = styled.section`
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid ${(props) => props.theme.application.border};
`;

const Title = styled.h3`
  margin: 0 0 10px;
  font-size: 1rem;
`;

const Supplier = styled.div<{ $met: boolean }>`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 4px 12px;
  padding: 8px 0;
  color: ${(props) => props.$met ? "#276749" : "#9b2c2c"};

  span:last-child {
    grid-column: 1 / -1;
    font-weight: 600;
  }
`;